import { withStyles } from '@mui/styles';
import { Button } from '@mui/material';
import { red } from '@mui/material/colors';
import { Theme } from '@mui/material/styles';

const DangerButton = withStyles((theme: Theme) => ({
    root: {
        color: theme.palette.getContrastText(red[500]),
        backgroundColor: red[500],
        '&:hover': {
            backgroundColor: red[700]
        }
    }
}))(Button);

export default DangerButton;
